import x from "../../../assets/images/X.png";
import back from "../../../assets/images/back.png";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import brands from "../../../Json/Brand.json";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
} from "../../../features/Products/ProductSlice";

function SeacrhMenuVintage({ show, setShow, id, setShowbefore, setShowfirst }) {
  const { i18n, t } = useTranslation();
  const { subtype } = useSelector((store) => store.topsearches);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const VintageDesigners = [
    {
      name: "Burberry",
      nameAr: "بربري",
    },
    {
      name: "Yves Saint Laurent",
      nameAr: "إيف سان لوران",
    },

    {
      name: "Celine",
      nameAr: "سيلين ",
    },
    {
      name: "Chanel",
      nameAr: "شانيل ",
    },
    {
      name: "Dior",
      nameAr: "ديور ",
    },
    {
      name: "Valentino Garavani",
      nameAr: "فالنتينو جارافاني",
    },
    {
      name: "Fendi",
      nameAr: "فندي  ",
    },

    {
      name: "Prada",
      nameAr: "برادا ",
    },

    {
      name: "Hermès",
      nameAr: "هيرميس ",
    },

    {
      name: "Jean-Paul Gaultier",
      nameAr: "جان بول غوتييه",
    },

    {
      name: "Louis Vuitton",
      nameAr: "لويس فويتون",
    },
    {
      name: "Courreges",
      nameAr: "كوريج",
    },
  ];
  return (
    <>
      <Modal show={show} fullscreen className="modal fade mx-0 px-0">
        <Modal.Body className="p-0 m-0 ">
          <div className="modal-header justify-content-between align-items-center d-flex pb-0 px-4">
            <div style={{ cursor: "pointer" }}>
              <button
                type="button"
                className="close close-txt close-modal align-items-center px-0"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShow(false)}
              >
                <img
                  alt="main"
                  src={back}
                  onClick={() => setShow(false)}
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </button>
            </div>
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <img
                alt="main"
                src={x}
                onClick={() => setShow(false)}
                className="x-close  mb-1"
              />
            </button>
          </div>

          <div className="modal-body px-4">
            {subtype == "Designers" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate("/brands") & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Designers")}
                  </div>
                </div>

                {VintageDesigners.map((brandsection) =>
                  brands
                    .filter((brand) => brand.name == brandsection.name)
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((sub) => (
                      <>
                        <div
                          className="searchmenunew pb-4"
                          onClick={() =>
                            setShow(false) &
                            setShowbefore(false) &
                            setShowfirst(false)
                          }
                        >
                          <div
                            onClick={() =>
                              navigate(
                                `/products?topic=Vintage&nameBrand=${sub.name}`
                              )
                            }
                            className="searchmenunew "
                          >
                            {i18n.language == "en" ? sub.name : sub.nameAr}
                          </div>
                        </div>
                      </>
                    ))
                )}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate("/products?topic=Vintage") &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Vintage")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Women" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&gender=WFA967se7qX0jYtySgTj&"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Women")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Bags")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Clothes")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Shoes")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Accessories")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Jewelry")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Watches")}
                  </div>
                </div>

                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("view-all")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Men" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&gender=KG3s4pPk3arcBux5ERnD&"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Men")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Bags")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Clothes")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Shoes")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Accessories")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Jewelry")}
                  </div>
                </div>
                <div
                  className="searchmenunew   pb-4"
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                      )
                    }
                    className="searchmenunew  "
                  >
                    {t("Watches")}
                  </div>
                </div>

                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=Vintage&gender=KG3s4pPk3arcBux5ERnD"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("view-all")}
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SeacrhMenuVintage;
